import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { CHALETS } from "@/lib/data";
import { scrollToId } from "@/lib/scroll";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Experience from "@/components/site/Experience";
import ChaletShowcase from "@/components/site/ChaletShowcase";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";

function App() {
  const [chaletId, setChaletId] = useState(CHALETS[0].id);
  const reserve = (id) => {
    setChaletId(id);
    scrollToId("reservar");
  };

  return (
    <div className="App">
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <section id="chales" className="bg-[#faf7f2]">
          {CHALETS.map((c, i) => (
            <ChaletShowcase key={c.id} chalet={c} reverse={i % 2 === 1} onReserve={() => reserve(c.id)} />
          ))}
        </section>
        <Experience />
        <Booking chaletId={chaletId} setChaletId={setChaletId} />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
